<template>
  <div class="page-main">
    <div class="loader row" v-if="loading">
      <div class="col-sm-12 fa-pull-right mr-0">
        <div>
          <img src="@/assets/preloader.gif" />
        </div>
      </div>
    </div>
    <div class="row mt-2 mb-3" v-if="!loading">
      <div class="col-sm-12 fa-pull-right mr-0">
        <b-button variant="success" class="mr-3"
                  v-if="selectedStatus === 1"
                  v-on:click="doAllocate">Allocate</b-button>
        <b-button variant="warning" class="mr-3"
                  v-if="selectedStatus === 20 || selectedStatus === 30 || selectedStatus === 35 || selectedStatus === 37"
                  v-on:click="doBulkGI">Bulk GI</b-button>
        <b-button variant="success" class="mr-3"
                  v-on:click="printSelected"
        >Print Picklist (Manual) [Ctrl+M]</b-button>
        <label style="font-size: large;font-weight: bold;">Daftar DO</label>

        <b-button class="ml-3"
                  :disabled="loading"
                  v-on:click="getDataDO">
          <b-icon icon="arrow-repeat"></b-icon>
        </b-button>

      </div>
    </div>
    <div class="row mt-2 mb-3" v-if="!loading">
      <div class="col-sm-3 fa-pull-right mr-0">
        <b-form-select v-model="selectedClient" :options="optionClient"></b-form-select>
      </div>
      <div class="col-sm-3 fa-pull-right mr-0">
        <b-form-select v-model="selectedArea" :options="optionArea"></b-form-select>
      </div>
      <div class="col-sm-2 fa-pull-right mr-0">
        <b-form-select v-model="selectedStatus" :options="optionStatus"></b-form-select>
      </div>
      <div class="col-sm-2 fa-pull-right mr-0">
        <b-form-select v-model="selectedPrinted" :options="optionPrinted"></b-form-select>
      </div>

      <div class="col-sm-2 fa-pull-right mr-0">
        <b-form-select v-model="selectedLimit" :options="optionLimit"></b-form-select>
      </div>
    </div>
    <div class="row mt-2 mb-3" v-if="!loading">
      <div class="col-sm-12 fa-pull-right mr-0">
        <b-form-input v-model="search" placeholder="Cari DO Reference" debounce="500"></b-form-input>
      </div>
    </div>
    <div class="row mt-2 mb-3">
      <div class="col-sm-12">
        <!-- START Data Table -->
        <div class="mb-4 mt-0 table-responsive">

          <!-- START TABLE RESPONSIVE -->
          <table class="table">
            <thead class="table-active">
            <tr>
              <th class="align-middle text-center"><i class="fas fa-ellipsis-v"></i></th>
              <th class="align-middle text-center"><input type="checkbox" v-model="selectAll"></th>
              <th class="align-middle">Client ID</th>
              <th class="align-middle">DO Reference</th>
              <th class="align-middle">Status</th>
              <th class="align-middle">Create Time</th>
              <th class="align-middle">Total Item</th>
              <th class="align-middle">Total Pcs</th>
              <th class="align-middle">Area</th>
              <th class="align-middle">Req Del Date</th>
              <th class="align-middle">Picker</th>
            </tr>
            </thead>
            <tbody>
            <template v-if="records.length < 1">
              <tr>
                <td colspan="10" class="text-center">Result: 0 Record</td>
              </tr>
            </template>
            <template v-for="(row,idx) in records">
              <tr :key="row.do_id">
                <td :title="idx+1">
                  <button class="btn btn-rounded btn-sm"
                          :class="{'btn-primary': !isSelected(row.do_id), 'btn-danger': isSelected(row.do_id)}"
                          style="padding: 0px 4px !important" @click="toggleDetail(idx)">
                    <font-awesome-icon icon="plus" v-if="!isSelected(row.do_id)"></font-awesome-icon>
                    <font-awesome-icon icon="minus" v-if="isSelected(row.do_id)"></font-awesome-icon>
                  </button>
                </td>
                <td class="align-top text-center">
                  <!-- <input type="checkbox" :disabled="row.do_status < 20 || row.do_status >= 40" v-model="selected" :value="row.do_id" /> -->
                  <input type="checkbox" :disabled="row.do_status >= 40" v-model="selected" :value="row.do_id" />
                </td>
                <td>{{ row.client_id }}</td>
                <td>{{ row.do_reference }}</td>
                <td>
                  <i v-if="row.do_status == 0" class="btn btn-danger">Unallocated</i>
                  <i v-if="row.do_status == 10" class="btn btn-warning">Partial Allocate</i>
                  <i v-if="row.do_status == 20" class="btn btn-warning">Full Allocated</i>
                  <i v-if="row.do_status == 30" class="btn btn-warning">Pick Confirmed</i>
                  <i v-if="row.do_status == 35" class="btn btn-info">Check Completed</i>
                  <i v-if="row.do_status == 37" class="btn btn-info">Pack Completed</i>
                  <i v-if="row.do_status == 40" class="btn btn-success">GI</i>
                  <i v-if="row.do_status == 100" class="btn btn-danger">Cancelled</i>
                  <template v-if="row.is_printed">
                    <i class="ml-2 btn btn-primary">Printed</i>
                  </template>
                </td>
                <td>{{ row.create_time }}</td>
                <td>{{ row.total_line }} </td>
                <td>{{ row.total_pcs }} </td>
                <td>{{ row.city_name }} </td>
                <td>{{ row.req_del_date }}</td>
                <td>{{ row.picker }}</td>
              </tr>
              <tr v-bind:key="row.do_id + '--' + idx" style="background-color: white !important;"
                  v-bind:class="{'hidden' : !isSelected(row.do_id)}"
                  class="table-ligh t">
                <td colspan="12">
                  <!-- START detail table -->
                  <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                      <a class="nav-link active" data-toggle="tab" v-bind:href="'#tabs1-' + row.do_id" role="tab">Details</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" data-toggle="tab" v-bind:href="'#tabs2-' + row.do_id" role="tab">Fulfil</a>
                    </li>
                  </ul>

                  <!-- Tab panes -->
                  <div class="tab-content mb-5">
                    <!-- DETAILS -->
                    <div class="tab-pane active" v-bind:id="'tabs1-' + row.do_id" role="tabpanel">
                      <div class="row">
                        <div class="col-sm-2 text-right">
                          Origin :
                        </div>
                        <div class="col-sm-10">
                          {{ row.origin_id }}
                        </div>
                        <div class="col-sm-2 text-right">
                          Destination ID :
                        </div>
                        <div class="col-sm-10">
                          {{ row.destination_id }}
                        </div>
                        <div class="col-sm-2 text-right">
                          Destination City:
                        </div>
                        <div class="col-sm-10">
                          {{ row.city_name }}
                        </div>
                        <div class="col-sm-2 text-right">
                          Destination Province:
                        </div>
                        <div class="col-sm-10">
                          {{ row.state_name }}
                        </div>
                        <div class="col-sm-2 text-right">
                          Create By :
                        </div>
                        <div class="col-sm-10">
                          {{ row.create_by }}
                        </div>
                        <div class="col-sm-2 text-right">
                          Last Update By :
                        </div>
                        <div class="col-sm-10">
                          {{ row.update_by }}
                        </div>
                        <div class="col-sm-2 text-right">
                          Last Update Time :
                        </div>
                        <div class="col-sm-10">
                          {{ row.update_time }}
                        </div>


                        <div class="col-sm-2 text-right">
                          SO ID :
                        </div>
                        <div class="col-sm-10">
                          {{ row.so_id }}
                        </div>
                        <div class="col-sm-2 text-right">
                          Transporter :
                        </div>
                        <div class="col-sm-10">
                          {{ row.transporter_id }}
                        </div>
                        <div class="col-sm-2 text-right">
                          COD Amount :
                        </div>
                        <div class="col-sm-10">
                          {{ row.cod_amount }}
                        </div>
                        <div class="col-sm-2 text-right">
                          Order Amount :
                        </div>
                        <div class="col-sm-10">
                          {{ row.order_amount }}
                        </div>

                        <div class="col-sm-2 text-right">
                          DO Remark :
                        </div>
                        <div class="col-sm-10">
                          {{ row.do_remark }}
                        </div>


                      </div>
                    </div>
                    <div class="tab-pane" v-bind:id="'tabs2-' + row.do_id" role="tabpanel">
                      <div class="row">
                        <div class="col-sm-2 text-right">
                          Picker :
                        </div>
                        <div class="col-sm-10">
                          {{ row.picker }}
                        </div>
                        <div class="col-sm-2 text-right">
                          Checker :
                        </div>
                        <div class="col-sm-10">
                          {{ row.checker }}
                        </div>
                        <div class="col-sm-2 text-right">
                          Supervisor :
                        </div>
                        <div class="col-sm-10">
                          {{ row.supervisor }}
                        </div>
                        <div class="col-sm-2 text-right">
                          Start Loading Time :
                        </div>
                        <div class="col-sm-10">
                          {{ row.start_loading_time }}
                        </div>
                        <div class="col-sm-2 text-right">
                          End Loading Time :
                        </div>
                        <div class="col-sm-10">
                          {{ row.end_loading_time }}
                        </div>
                        <div class="col-sm-2 text-right">
                          Packing Status :
                        </div>
                        <div class="col-sm-10">
                          {{ row.packing_status }}
                        </div>
                        <div class="col-sm-2 text-right">
                          Checking Status :
                        </div>
                        <div class="col-sm-10">
                          {{ row.checking_status }}
                        </div>
                        <!--
                        <div class="col-sm-2 text-right">
                          Printed :
                        </div>
                        <div class="col-sm-10">
                          {{ row.is_printed }}
                        </div>
                        -->
                      </div>
                    </div>
                  </div>
                  <!-- END detail table -->

                </td>
              </tr>
            </template>
            </tbody>
          </table>
          <div style="display: none" id="panel-print-area">
            <div id="print-area" class="print-area" ref="printArea">
              <template v-for="(picklist) in picklistRows">
                <div size="A4" :key="picklist.do_id">
                  <div class="ml-2">
                    <h5>Order Picklist <span v-if="picklist.reprinted">[REPRINT]</span></h5>
                    <span>Printed time: {{ timeNow }} by: {{ currentUser }}</span>
                  </div>

                  <table class="table A4 landscape table-borderless">
                    <tbody>
                    <tr>
                      <td style="border: none;" class="float-leftx no-border" colspan="1">Picker: {{ picklist.picker === '' ||  picklist.picker === null ? '--' : picklist.picker }}</td>
                      <td style="border: none;" class="float-leftx no-border" colspan="2">Customer: {{ picklist.customer }}</td>
                      <td style="border: none;" class="no-border">Client: {{ picklist.client_id }}</td>
                    </tr>

                    <tr>
                      <td class="no-border">DO Reference: <br/>
                        {{ picklist.do_reference }}
                      </td>
                      <td class="no-border" colspan="1">
                        <div>
                          <barcode :value="picklist.do_reference"
                                   :width="1"
                                   :fontSize="11"
                                   :options="{ lineColor: '#0f1315', text: picklist.do_reference}"></barcode>
                        </div>
                      </td>
                      <td class="float-right no-border">DO ID</td>
                      <td colspan="2">
                        <barcode :value="picklist.do_id"
                                 :width="2"
                                 :fontSize="11"
                                 :options="{ lineColor: '#0F1315', text: picklist.do_id}"></barcode>
                      </td>
                    </tr>
                    <tr>
                      <td class="no-border">Req Del Date: {{ picklist.req_del_date }}</td>
                      <td class="no-border text-right" colspan="2">Transporter: {{ picklist.transporter_id }}</td>
                      <td class="no-border text-right" colspan="2">Service Type: {{ picklist.service_type }}</td>
                      <td class="no-border text-right" colspan="2">Dest City: {{ picklist.dest_city }}</td>
                    </tr>
                    <tr>
                      <td class="no-border" colspan="7">Remark: {{ picklist.do_remark }}</td>
                    </tr>
                    <tr>
                      <td colspan="7">
                        <table class="table">
                          <thead class="table-active">
                          <tr>
                            <th class="align-middle">Location</th>
                            <th class="align-middle">Product Id</th>
                            <th class="align-middle">Product Desc</th>
                            <th class="align-middle">Batch</th>
                            <th class="align-middle">Expired Date</th>
                            <th class="align-middle">Qty</th>
                            <th class="align-middle">UoM</th>
                          </tr>
                          </thead>
                          <tbody>
                          <template v-for="(line,idx) in picklist.lines">
                            <tr :key="idx">
                              <td>{{ line.location }}</td>
                              <td>{{ line.product_id }}</td>
                              <td>{{ line.product_description }}</td>
                              <td>{{ line.batch }}</td>
                              <td>{{ line.expired_date }}</td>
                              <td>{{ line.qty }}</td>
                              <td>{{ line.uom }} </td>
                            </tr>
                          </template>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal ref="ref-modal-warning" id="modal-warning" hide-footer title="Generate List">
      <div class="d-block text-center">
        <h3>Too Many Order</h3>
        <p>
          Harap pilih tidak lebih dari <span>{{ maxDO }}</span> DO
        </p>
      </div>
      <b-button ref="ref-modal-do-close" variant="outline-success" class="mt-3" block
                @click="$bvModal.hide('modal-warning')">OK</b-button>
    </b-modal>

    <b-modal ref="ref-modal-nopick" id="modal-nopick" hide-footer title="Pick List">
      <div class="d-block text-center">
        <h3>Tidak Ada Picklist </h3>
        <p>
          Tidak ada list untuk DO yang dipilih
        </p>
      </div>
      <b-button ref="ref-modal-do-close-nopick" variant="outline-success" class="mt-3" block
                @click="$bvModal.hide('modal-nopick')">OK</b-button>
    </b-modal>

    <b-modal
        ref="ref-modal-allocate"
        :title="titleAllocate"
        :header-bg-variant="headerBgVariant"
        :header-text-variant="headerTextVariant"
        id="modal-allocate"
        @hide="getDataDO"
        hide-footer
        hide-header-close
        no-close-on-backdrop
        no-close-on-esc>
      <div class="d-block text-center">
        <h3>Detail Progress: </h3>
        <template v-for="(alloc,idx) in allocateResult" >
          <div :key="idx">
            <i class="btn btn-success" v-if="alloc.status === 200"></i>
            <i class="btn btn-danger" v-if="alloc.status !== 200"></i>
            {{ alloc.message }}
          </div>
        </template>
        <div v-if="processAllocate">
          <img alt="Loading..." src="@/assets/preloader.gif" />
        </div>
        <div v-if="errorAllocate !== ''" style="color: darkred">
          {{ errorAllocate }}
        </div>
      </div>
      <b-button ref="ref-modal-do-close-allocate"
                variant="outline-success" class="mt-4" block
                v-if="!processAllocate"
                @click="$bvModal.hide('modal-allocate')">Tutup</b-button>
    </b-modal>


    <b-modal
        ref="ref-modal-bulk-gi"
        :title="titleBulkGI"
        :header-bg-variant="headerBgVariant"
        :header-text-variant="headerTextVariant"
        id="modal-gi"
        @hide="getDataDO"
        hide-footer
        hide-header-close
        no-close-on-backdrop
        no-close-on-esc>
      <div class="d-block text-center">
        <h3>Detail Progress: </h3>
        <template v-for="(alloc,idx) in giResult" >
          <div :key="idx">
            <i class="btn btn-success" v-if="alloc.status === 200"></i>
            <i class="btn btn-danger" v-if="alloc.status !== 200"></i>
            {{ alloc.message }}
          </div>
        </template>
        <div v-if="processGI">
          <img alt="Loading..." src="@/assets/preloader.gif" />
        </div>
        <div v-if="errorGI !== ''" style="color: darkred">
          {{ errorGI }}
        </div>
      </div>
      <b-button ref="ref-modal-do-close-gi"
                variant="outline-success" class="mt-4" block
                v-if="!processGI"
                @click="$bvModal.hide('modal-gi')">Tutup</b-button>
    </b-modal>

  </div>
</template>

<script>
import DOService from '../services/do.service'
import jQuery from 'jquery'
import Moment from 'moment'
import ClientCommon from "@/components/mixins/ClientCommon";
import TxAllocate from "@/components/mixins/TxAllocate";
import TxBulkGI from "@/components/mixins/TxBulkGI";

export default {
  name: 'Home',
  mixins: [ClientCommon,TxAllocate, TxBulkGI],
  data() {
    return {
      maxDO: Number(process.env.VUE_APP_MAX_PRINT),
      autoPrint: ( Number(process.env.VUE_APP_AUTO_PRINT) === 1),
      printTime: '',
      barcodeDORef: {
        with: '10px',
      },
      loading: false,
      loadingData: false,
      content: '',
      search: '',
      records: [],
      printing: false,
      picklistRows: [],
      selected: [],
      selected_data: {
        id: 0,
        data: {}
      },
      selectedPrinted: null,
      optionPrinted: [
        { value: null, text: 'Semua Kondisi Print ' },
        { value: 0, text: 'Belum Print' },
        { value: 1, text: 'Printed' },
      ],
      selectedStatus: null,
      optionStatus: [
        { value: null, text: 'Pilih Status' },
        { value: 1, text: 'Unallocated' },
        { value: 10, text: 'Partial Allocate' },
        { value: 20, text: 'Full Allocated' },
        { value: 30, text: 'Pick Confirmed' },
        { value: 35, text: 'Check Completed' },
        { value: 37, text: 'Pack Completed' },
        { value: 40, text: 'GI' },
        { value: 100, text: 'Cancelled' },
      ],
      selectedLimit: 50,
      optionLimit: [
        { value: 10, text: '10 Row' },
        { value: 20, text: '20 Row' },
        { value: 50, text: '50 Row' },
        { value: 100, text: '100 Row' },
        { value: 150, text: '150 Row' },
        { value: 200, text: '200 Row' },
        { value: 250, text: '250 Row' },
        { value: 300, text: '300 Row' },
      ],
    };
  },
  computed: {
    selectAll: {
      get: function () {
        return this.records ? this.selected.length === this.records.length : false;
      },
      set: function (value) {
        let selected = [];
        if (value) {
          this.records.forEach(function (record) {
            if (record.do_status < 40)
              selected.push(record.do_id);
          });
        }
        this.selected = selected;
      }
    },
    timeNow: function() {
      return Moment().format('DD MMM YYYY - HH:mm:ss')
    },
    currentUser() {
      return this.$store.state.auth.user.username;
    },
  },
  watch: {
    selectedClient: function () {
      this.getDataDO()
    },
    selectedStatus: function () {
      this.getDataDO()
    },
    selectedPrinted: function () {
      this.getDataDO()
    },
    selectedArea: function () {
      this.getDataDO()
    },
    selectedLimit: function () {
      this.getDataDO()
    },
    search: function (val) {
      /* eslint-disable no-console */
      //console.log(">>>> " + val)
      /* eslint-enable no-console */
      if (val !== "" ) {
        val = val.replaceAll(' ',',')
        DOService.searchDO(val).then(
            response => {
              this.records = response.data;
            },
            error => {
              /* eslint-disable no-console */
              //console.log(error.response.status)
              /* eslint-enable no-console */

              if (error.response.status === 401) {
                this.$store.dispatch('auth/logout');
                this.$router.push('/login')
              }

              this.content =
                  (error.response && error.response.data) ||
                  error.message ||
                  error.toString();
            }
        )
      } else {
        this.getDataDO()
      }
    },
  },
  methods: {
    isSelected: function(doId) {
      return this.selected_data.id > 0
            && doId === this.selected_data.id
    },
    doPrint: function (){
      this.printTime = Moment().format('DD MMM YYYY - HH:mm:ss')

      let defaultName = '_blank',
          defaultSpecs = ['fullscreen=yes','titlebar=yes', 'scrollbars=yes'],
          //defaultReplace = true,
          defaultStyles = [
            "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
            "https://unpkg.com/kidlat-css/css/kidlat.css",
            "/css/print.css",
          ]

      const options = {
        name: "_blank",
        specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
        styles: [
          "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
          //"https://unpkg.com/kidlat-css/css/kidlat.css",
          "/css/print.css",
        ]
      }

      let {
        name = defaultName,
        specs = defaultSpecs,
        //replace = defaultReplace,
        styles = defaultStyles
      } = options;

      const printArea = this.$refs.printArea

      /* eslint-disable no-console */
      //console.log(">>>> {}", printArea)
      /* eslint-enable no-console */

      if (!printArea) {
        alert("Element to print #${'print-area'} not found!");
        return;
      }

      const url = ''
      //let toPrintElement = element.innerHTML
      //Skipping fourth element:
      //Error: A boolean is being passed as a fourth parameter to window.open. This is not used and may cause an exception in a future release.
      const win = window.open(url, name, specs)
      win.document.write(`
            <html>
              <head>
                <title>${window.document.title}</title>
                <style></style>
              </head>
              <body></body>
            </html>
          `)

      //addStyles(win, styles);
      styles.forEach(style => {
        let link = win.document.createElement('link');
        link.setAttribute('rel', 'stylesheet');
        link.setAttribute('type', 'text/css');
        link.setAttribute('href', style);
        win.document
            .getElementsByTagName('head')[0]
            .appendChild(link)
      })
      win.document
          .getElementsByTagName('body')[0]
          .appendChild( printArea )

      window.addEventListener("unload", setPanel, false);
      let panel = jQuery("#panel-print-area")
      function setPanel() {
        //SOMEWHAT VUE MAKE IT DETACHED AND DISPOSE
        //WE NEED TO ATTACH THE NODE AGAIN!
        panel.append( printArea )
        //console.log(">>>> INSIDE {}", printArea)
      }

      let vm = this
      setTimeout(() => {
        win.document.close();
        win.focus();
        if (vm.autoPrint) {
          win.print();
        }
        vm.printing = false

        if (vm.autoPrint) {
          win.close();
        }
        //cb();
      }, 1000)

      /* eslint-enable no-console */

    },
    printSelected: function () {
      if (this.selected.length > this.maxDO) {
        this.$refs['ref-modal-warning'].show()
        return
      }
      this.loading = true
      this.picklistRows = []

      DOService.getPicklist(this.selected).then(
          response => {
            this.loading = false
            if (response.data.length < 1) {
              this.$refs['ref-modal-nopick'].show()
              return
            }
            this.picklistRows = response.data;
            this.printing = true
            this.doPrint()
          },
          error => {
            this.loading = false

            /* eslint-disable no-console */
            //console.log(error.response.status)
            /* eslint-enable no-console */

            if (error.response.status === 401) {
              this.$store.dispatch('auth/logout');
              this.$router.push('/login')
            }

            this.content =
                (error.response && error.response.data) ||
                error.message ||
                error.toString();
          }
      );

    },
    goToProcessAuto: function () {
      this.$router.push('/do/config/auto/1')
    },
    docKeyUpCtrlA: function(e) {
      // CTRL + A
      if (e.ctrlKey && e.keyCode == 65) {
        this.$router.push('/do/config/auto/1')
      }
    },

    triggerGetDO(){

    },
    getDataDO() {
      if (this.loadingData) {
        return
      }
      this.selected = []
      this.loading = true
      this.loadingData = true
      let filter = {}
      if (this.selectedClient != null) {
        filter.client_id = this.selectedClient
      }
      if (this.selectedStatus != null) {
        filter.status = this.selectedStatus
      }
      if (this.selectedArea != null) {
        filter.area = this.selectedArea
      }
      if (this.selectedPrinted != null) {
        filter.printed = this.selectedPrinted
      }
      filter.limit = this.selectedLimit
      DOService.getDO(filter).then(
          response => {
            this.loading = false
            this.loadingData = false
            this.records = response.data;

            /* eslint-disable no-console */
            //console.log(">>>>>>")
            //console.log(this.selected_data)
            /* eslint-enable no-console */
          },
          error => {
            this.loading = false
            this.loadingData = false
            /* eslint-disable no-console */
            //console.log(error.response.status)
            /* eslint-enable no-console */

            if (error.response.status === 401) {
              this.$store.dispatch('auth/logout');
              this.$router.push('/login')
            }

            this.content =
                (error.response && error.response.data) ||
                error.message ||
                error.toString();
          }
      );
    },
    toggleDetail(idx) {
      let  currentlySelected = this.records[idx];
      if (this.selected_data.id && this.selected_data.id == currentlySelected.do_id) {
        this.selected_data = {}
        //return;
      }else{
        this.selected_data = { id : currentlySelected.do_id }
      }
    },

    doAllocate() {
      if (this.selected < 1) {
        alert('Pilih DO terlebih dahulu')
        return
      }
      this.$refs['ref-modal-allocate'].show()
      this.processAllocate = true
      this.doCallServerAllocate(this.selected)
    },
    doBulkGI() {
      if (this.selected < 1) {
        alert('Pilih DO terlebih dahulu')
        return
      }
      this.$refs['ref-modal-bulk-gi'].show()
      this.processGI = true
      this.doCallServerBulkGI(this.selected, this.getDataDO)
    },
  },
  mounted() {
    let vm = this
    function doc_keyUp_Ctrl_M(e) {
      // CTRL + A
      if (e.ctrlKey && e.keyCode == 77) {
        // call your function to do the thing
        //alert('TEST + M');
        vm.printSelected()
      }
    }    // register the handler
    document.addEventListener('keyup', this.docKeyUpCtrlA, false);
    document.addEventListener('keyup', doc_keyUp_Ctrl_M, false);

    this.loading = false
    this.getDataDO()
    this.getClients()
    this.getArea()

    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      if (modalId === 'modal-allocate') {
        this.getDataDO()
      }
    })

    this.$nextTick(function () {
      // Code that will run only after the
      // entire view has been rendered
      /* eslint-disable no-console */
      //console.log("@@@@@@@@@@@ >>>> ")
      /* eslint-enable no-console */
    })
  },
  updated: function () {
    //let vm = this
    this.$nextTick(function () {
      // Code that will run only after the
      // entire view has been re-rendered
      /* eslint-disable no-console */
      //console.log("@@@@@@@@@@@ UPDATED ")
      /* eslint-enable no-console */
      //if (vm.printing) {
      //  vm.doPrint()
      //}
    })
  }
};
</script>
<style scoped>
.hidden{
  display: none;
}
/* loader */
.loader{
  position: fixed;
  color: white;
  background: #ffffff;
  width: 100%;
  height: 100%;
  z-index: 9999;
}
.borderless td, .borderless th {
  border: none;
}
.no-border {
  border: none;
}
</style>
